import { useEffect, useState } from 'react';
import {
  isEmbedPath,
  isPresented,
  onAfterPresentation,
} from '../lib/presentation/afterPresentation';

/**
 * true depois que a barreira de apresentação abriu.
 *
 * Com `active` falso a barreira não é armada e o retorno é sempre true, para
 * que as rotas fora do embed não paguem nenhum custo.
 *
 * O primeiro render é sempre false, no servidor e no cliente, para que a
 * árvore hidratada seja idêntica à do SSR.
 */
export function useAfterPresentation(active = true): boolean {
  const [presented, setPresented] = useState<boolean>(() =>
    typeof window === 'undefined' ? false : isPresented(),
  );

  useEffect(() => {
    if (!active || presented) return undefined;
    return onAfterPresentation(() => setPresented(true));
  }, [active, presented]);

  return active ? presented : true;
}

export { isEmbedPath };
